module.exports = __webpack_public_path__ + "img/tick.1a6a9a62.svg";